// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j2-0";
export var fileCarousel = "_j2-2";
export var removeFileButton = "_j2-1";